import { combineEpics } from 'redux-observable';
import copyBoard from './copy-board/index.tsx';

export default combineEpics(copyBoard);
